/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'add-icon': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M8 1v14M8 1v14M1 7.998h14M1 7.998h14" _stroke="#fff" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/add-icon.js